export function generateClipIdentifierClass(clipId: string) {
    return `clip-${clipId}`;
}